import { normalizeAssemblyName } from './normalizeAssemblyName'

const SYSTEM_ASSEMBLIES = new Set([
  '',
  'mscorlib',
  'java.base',
  'system.private.corelib',
  'netstandard',
  'system.runtime',
])

export const isSystemAssembly = (assemblyName: string | undefined): boolean => {
  const normalized = normalizeAssemblyName(assemblyName).toLowerCase()
  return SYSTEM_ASSEMBLIES.has(normalized)
}
